var React = require('react');

function Loader2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_330)","key":0},[React.createElement("rect",{"width":"90","height":"37","fill":"white","key":0}),React.createElement("rect",{"y":"73","width":"90","height":"37","fill":"white","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_330"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader2.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader2;

Loader2.default = Loader2;
